import ThreshIcon from '@/assets/icons/delete.svg?react';
import { IconButton } from '@/lib';
import { TranslationKeys } from '@/localization';
import { CampaignResponse } from '@/services/endpoints/campaigns/types';
import { FC, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteCampaignModal } from '../CampaignSettings/parts';

type CampaignDeleteButtonProps = {
  campaign: CampaignResponse;
  buttonText?: TranslationKeys;
};

export const CampaignDeleteButton: FC<CampaignDeleteButtonProps> = ({ campaign, buttonText }) => {
  const { t } = useTranslation();

  const [isModalOpen, toggleModal] = useReducer((state) => !state, false);

  return (
    <>
      <IconButton
        intent='link-grey'
        className='!p-1.5 text-tertiary-600'
        text={t(buttonText as any)}
        leadingIcon={<ThreshIcon className='text-quaternary-400' />}
        onClick={toggleModal}
      />
      {isModalOpen && <DeleteCampaignModal campaign={campaign} closeModal={toggleModal} />}
    </>
  );
};
